import React from 'react';

const AddProduct = (props) => {
  return(
    <div className="card">
      <div className="card-header card-header-inverse">
        <h4 className="mb-0">{props.title}</h4>
      </div>
      <div className="card-block">
        <form className="row">

          {props.isClear?
            <div className={`form-group col-12 col-sm-12 col-md-4 ${(props.errors.indexOf('item') !== -1) ? "has-danger" : ""}`}>
              <select id="select" name="select" className={(props.errors.indexOf('item') !== -1) ? "form-control form-control-danger" : "form-control"} size="1" value={props.itemIndex} onChange={(item) => props.onItemChange(item)}>
                <option value={-1}>Select Product</option>
                  {props.items? (props.items.map((item,index) => {
                        return(<option value={item.id} label={item.name} key={item.id}>{item.name}</option>)
                      })) : <option value=" ">Loading...</option>
                  }
              </select>
              {(props.errors.indexOf('item') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select Product</em> : <em></em>}
            </div>
             :
            (<div className="d-flex">
              <div className="form-group">
                <div className="input-group">
                  <input className="form-control" type="text" value={props.preselectedProduct? props.preselectedProduct.name : ''} disabled='true'/>
                </div>
              </div>
              <div>
                <span className="btn btn-danger" onClick={props.onClear}><i className="fa fa-times"></i>Select another</span>
              </div>
            </div>
            )
          }

          <div className={`form-group col-12 col-sm-6 col-md-4 ${(props.errors.indexOf('amount') !== -1 || props.amount < 0) && "has-danger"}`} >
            <div className="input-group">
              <input type="number"
                     min={1}
                     className={`form-control ${(props.errors.indexOf('amount') !== -1) ? "form-control-danger" : ""}`}
                     value={props.amount} onChange={(amount) => props.onAmountChange(amount)}
                     disabled={props.disableAmountInput || props.isSubmittingItems}
                     placeholder="Quantity"/>
              <div className="input-group-addon">{props.item ? (props.item.measure_unit ? props.item.measure_unit : 'lb') : 'lb'}</div>
            </div>
            {(props.errors.indexOf('amount') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter amount greater than 0</em> : <em></em>}
          </div>

          <div className={`form-group col-12 col-sm-6 col-md-4 ${(props.errors.indexOf('pieces') !== -1 || props.pieces < 0) && "has-danger"}`}>
            <div className="input-group">
              <input type="number"
                   min={1}
                   className={`form-control ${(props.errors.indexOf('pieces') !== -1) ? "form-control-danger" : ""}`}
                   value={props.pieces} onChange={(pieces) => props.onPiecesChange(pieces)}
                   disabled={props.disablePiecesInput || props.isSubmittingItems}
                   placeholder="Pieces"/>
               <div className="input-group-addon">Pieces</div>
            </div>
            {(props.errors.indexOf('pieces') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter pieces greater than 0</em> : <em></em>}
          </div>

          <div className="row justify-content-end w-100">
            <div className="add-repeat-btn">
                <span className="pr-05">Repeat</span>
                <input type="number" className={`form-control w-10 ${(props.errors.indexOf('repeat') !== -1) ? "form-control-danger" : ""}`}
                  value={props.times}
                  onChange={(times) => props.onTimesChange(times)}/>
                <span className="pl-05 pr-05">times</span>
                <span className="btn btn-success m-0" onClick={() => props.isSubmittingItems ? "" : props.onAddItem()}><i className="hidden-xxs-down fa fa-plus mr-05"></i>Add</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddProduct;
